import type { TagApps } from './tag-apps';
import type { AppDataType } from '../app-market-client-aggregator';
import type { QueryAppsFilter, SupportedAppStatuses } from '../../types';

export const APPS_LIMIT = 48;

export enum SortType {
  COUNTRY_CODE = 'COUNTRY_CODE',
  APP_MARKET_SCORE = 'APP_MARKET_SCORE',
  DEALER = 'DEALER',
  DATE_CREATED = 'DATE_CREATED',
  REVIEWS_RATING = 'REVIEWS_RATING',
  MOST_INSTALLED = 'MOST_INSTALLED',
  MANUAL = 'MANUAL',
  ML_MODEL_RANKING = 'ML_MODEL_RANKING',
  UNKNOWN = 'UNKNOWN',
}

export type queryTagApp = (payload: {
  appIds?: string[];
  tagIds?: string[] | { $in: string[] };
}) => Promise<TagApps>;

export type getAppsDataByTagId = (payload: {
  tagId: string;
  sortTypes?: SortType[];
  limit?: number;
  offset?: number;
  status: SupportedAppStatuses;
  filter?: QueryAppsFilter;
}) => Promise<{
  apps: AppDataType[];
  hasNext: boolean;
  total: number;
}>;
